export default __webpack_public_path__ + "static/media/CA.56db57c2.svg";